<template>
  <div class="fillheight">
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        v-model="form_map.layers"
        :api="api"
        :headers="headers"
        :params="params"
        :defaultParams="default_params"
        use-grid
        use-scroll-load
        use-top
        use-selected
        multi-select
      >
        <!-- <template #below-top>
          <v-card
            class="
              d-flex
              align-md-center
              pa-1
              flex-column flex-md-row
              mt-0
              mb-4
            "
            outlined
          >
            <div>Chọn lớp ở dưới để thêm vào bản đồ</div>
            <v-spacer></v-spacer>
            <div class="d-flex align-center">
              <v-select
                v-model="form_map.map"
                dense
                hide-details
                outlined
                class="mx-2"
                single-line
                return-object
                item-value="id"
                item-text="name"
                :loading="map_items.loading"
                :items="mapItemSelect"
              />
              <base-button
                color="primary"
                @click="onCreateMap()"
                outlined
                :disabled="form_map.layers.length < 1 || !form_map.map"
              >
                {{ form_map.map && form_map.map.nodata ? 'Thêm' : 'Cập nhật' }}
                bản đồ
              </base-button>
              <base-button
                className="ml-1"
                @click="onPreview(form_map.layers)"
                outlined
                :disabled="form_map.layers.length < 1"
              >
                Xem trước
              </base-button>
              <base-button
                className="ml-1"
                @click="showShareDialog(form_map.layers)"
                outlined
                :disabled="form_map.layers.length < 1"
              >
                Chia sẻ
              </base-button>
            </div>
          </v-card>
        </template> -->
        <template #top-append-right>
          <v-text-field
            v-model="params.search"
            clearable
            dense
            hide-details
            outlined
            placeholder="Tìm kiếm theo tên"
            prepend-inner-icon="mdi-magnify"
            single-line
          />
        </template>
        <template #grid-item="{ item }">
          <div class="d-flex justify-end align-end">
            <div class="btn-group">
              <!-- <base-button
                class="text-none"
                text
                @click.stop="showShareDialog([item])"
                icon
                tooltip="Chia sẻ"
              >
                <v-icon>mdi-share-variant</v-icon>
              </base-button> -->

              <base-button
                class="text-none"
                text
                @click.stop="onPreview([item])"
                icon
                :tooltip="$t('layer.action.preview')"
              >
                <v-icon>mdi-eye</v-icon>
              </base-button>
              <base-button
                class="text-none"
                @click.stop="exportExcel(item)"
                icon
                :loading="loadingExport == item.id"
                :disabled="loadingExport != -1 && loadingExport != item.id"
                :tooltip="$t('layer.action.export')"
              >
                <v-icon>mdi-microsoft-excel</v-icon>
              </base-button>
              <base-button-group
                icon="mdi-dots-vertical"
                :items="menus"
                :value="item"
                force-in-menu
              ></base-button-group>
            </div>
          </div>
          <layer-item :value="item" :workspace="workspace"> </layer-item>
        </template>
      </base-serve-table>
    </v-sheet>
    <LayerUpdateDialog ref="updateDialog" @reset="onReset" />
    <LayerStyleDialog ref="LayerStyleDialog" @reset="onReset" />
    <!-- <LayerInfoDialog ref="LayerInfoDialog" @reset="onReset" /> -->
    <ShareDialog :typeLayer="'layer_ids'" ref="shareDialog" />
    <LayerField :id="datastore_detail_id" ref="layerField" />
    <LayerFeature
      :id="datastore_detail_id"
      :fields="fields"
      ref="layerFeature"
    />
    <!-- <FeatureInfoDialog /> -->
  </div>
</template>

<script>
import LayerItem from './layer-item.vue'
import { API_LAYER, API_LAYERGROUP } from '@api'
import { ConfirmBuilder } from '@utils'
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
import LayerUpdateDialog from './layer-update-dialog.vue'
import LayerStyleDialog from './layer-style-dialog.vue'
import { saveAs } from 'file-saver'
import LayerInfoDialog from './layer-info-dialog.vue'
import ShareDialog from '../share/share-dialog.vue'
import LayerField from '../datastores/datastore-detail-item/field.vue'
import LayerFeature from '../datastores/datastore-detail-item/feature.vue'
import { sdk } from '@service/http/axios'
export default {
  mixins: [],
  components: {
    LayerItem,
    LayerUpdateDialog,
    LayerStyleDialog,
    // LayerInfoDialog,
    ShareDialog,
    LayerField,
    LayerFeature,
  },
  props: {
    workspace: { type: Object, default: () => ({}) },
    id: [String, Number],
  },
  data: (vm) => ({
    datastore_detail_id: 0,
    fields: [],
    form_map: {
      layers: [],
      map: null,
    },
    default_params: {
      workspace_id: vm.id,
      is_publish: true,
    },
    params: { search: '', inactive: null },
    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
      },
      {
        text: 'Ngày cập nhật',
        align: 'start',
        sortable: true,
        value: 'updated_at',
      },
    ],
    loading: false,
    map_items: { items: [], loading: false },
    loadingExport: -1,
    menus: [
      // {
      //   icon: 'mdi-format-list-bulleted',
      //   title: 'Thông tin thuộc tính',
      //   handler: (item) => vm.onShowDialogInfo(item),
      //   disabled: (item) => !vm.checkAccess('layer.update', item),
      // },
      {
        icon: 'mdi-information-outline',
        title: 'Trường dữ liệu',
        handler: (item) => vm.onShowLayerFields(item),
        disabled: (item) => !vm.checkAccess('layer.update', item),
      },
      {
        icon: 'mdi-information-outline',
        title: 'Dữ liệu',
        handler: (item) => vm.onShowLayerFeatures(item),
        disabled: (item) => !vm.checkAccess('layer.update', item),
      },
      // {
      //   icon: 'mdi-palette',
      //   title: vm.$t('map.layer.action.change-style'),
      //   handler: (item) => vm.onUpdateStyleItem(item),
      //   disabled: (item) => !vm.checkAccess('layer.update', item),
      // },
      {
        type: 'setting',
        handler: (item) => vm.onUpdateItem(item),
        disabled: (item) => !vm.checkAccess('layer.update', item),
      },
      // {
      //   icon: (item) => (item.home_public ? 'mdi-blur-off ' : 'mdi-web'),
      //   title: (item) =>
      //     item.home_public ? 'Bỏ công khai dữ liệu' : 'Công khai dữ liệu',
      //   handler: (item) => vm.onPublicData(item),
      //   disabled: (item) => !vm.checkAccess('layer.update', item),
      // },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => !vm.checkAccess('layer.delete', item),
      },
    ],
  }),
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    api() {
      return API_LAYER
    },
    mapItemSelect() {
      return [
        ...this.map_items.items,
        { name: this.$i18n.t('layer.createMap'), nodata: true, id: 'newnew' },
      ]
    },
  },
  mounted() {
    this.getMapData()
    this.form_map.map = { name: this.$i18n.t('layer.createMap'), nodata: true }
  },
  methods: {
    onUpdateStyleItem(item) {
      this.$refs.LayerStyleDialog.open(item)
    },
    async onPublicData(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage(
          'Dữ liệu ' +
            item.name +
            ' sẽ được công khai và hiển thị trên trang chủ!'
        )
        .setTitle('Công khai dữ liệu')
        .setType('update')
      if (await confirm.confirm()) {
        const result = await this.api.publicLayer(item.id, { type: 'layer' })
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    getMapData() {
      // this.map_items.loading = true
      // API_LAYERGROUP.list({
      //   workspace_id: this.id,
      // })
      //   .then((res) => {
      //     this.map_items.items = res.data
      //   })
      //   .finally(() => {
      //     this.map_items.loading = false
      //   })
    },
    onResetPassword(item) {
      this.$refs.resetdialog.open(item)
    },
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.username },
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await this.api.destroy(item.id)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    showShareDialog(item) {
      this.$refs.shareDialog.open(item)
    },
    onUpdateItem(item) {
      this.$refs.updateDialog.open(item, EDIT_TYPE.UPDATE)
    },
    onReset() {
      this.$refs.table.reload()
    },
    onCreateMap() {
      let isCreate = this.form_map.map.nodata
      this.$emit('click:add-map', {
        name: isCreate ? 'Bản đồ mới' : this.form_map.map.name,
        ...this.form_map.map,
        layers: this.form_map.layers.map((x) => ({
          ...x,
          workspace: this.workspace,
        })),
        type: isCreate ? EDIT_TYPE.CREATE : EDIT_TYPE.UPDATE,
      })
    },
    onPreview(layers) {
      if (!layers || layers.length < 1) return
      this.$router.push({
        name: 'map',
        query: { layer_ids: layers.map((x) => x.id).join(',') },
      })
    },
    async exportExcel(layer) {
      this.loadingExport = layer.id
      const res = await this.api.export(layer.id)
      if (res && res.isDone) {
        saveAs(new Blob([res.data]), `${layer.name}.xlsx`)
      }
      this.loadingExport = -1
    },
    // onShowDialogInfo(item) {
    //   this.$refs.LayerInfoDialog.open(item)
    // },
    onShowLayerFields(item) {
      this.datastore_detail_id = item.datastore_detail_id
      this.$refs.layerField.open()
    },
    async onShowLayerFeatures(item) {
      this.datastore_detail_id = item.datastore_detail_id
      const res = await sdk.request({
        url: `datastore-details/${this.datastore_detail_id}/fields`,
        method: 'get',
      })
      this.fields = res.data
      this.$refs.layerFeature.open()
    },
  },
}
</script>
